import React, { useEffect, useRef } from 'react'
import { CustomerCardModel } from '../models/CustomerCardModel';

interface Props {
    folderList: any[];
    folderId: string;
    onClose: () => void;
    customerId: string;
}

const EditFolderInfoPopUp = (props: Props) => {
    const customerCardModel = useRef(new CustomerCardModel()).current;

    const [newFolderName, setNewFolderName] = React.useState<string>('');

    useEffect(() => {

        const folder = props.folderList.find(folder => folder.id === props.folderId);
        if (folder) {
            setNewFolderName(folder.name || '');
        } else {
            setNewFolderName('');
        }
      
    }, [])
    

    const uploadFile = async () => {

        let resp = await customerCardModel.customerDocumentsCreateFolder({
            id: props.folderId,
            name: newFolderName,
            customerId: props.customerId
        })

        // Logic to upload file goes here
        console.log('Uploading file...');
        props.onClose();
    }
    return (
        <div className="udp-modal-overlay">
            <div className="udp-modal" style={{ maxWidth: '20%' }}>

                <div className="udp-header">
                    <h2>עריכת תיקייה</h2>
                    <button className="udp-close-button" onClick={props.onClose}>X</button>
                </div>

                <div className="udp-selectors">

                    <input
                        type="text"
                        placeholder="שם תיקייה "
                        value={newFolderName}
                        onChange={(e) => setNewFolderName(e.target.value)}
                    />
                </div>

                <div className="udp-footer">
                    <button className="udp-close-btn" onClick={uploadFile}>שמור</button>
                </div>

            </div>

        </div>
    )
}

export default EditFolderInfoPopUp